/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Partial_HintInputs */

const cs_deal_payments_partial_hint = /** @type {(inputs: Deal_Payments_Partial_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Částečně zaplaceno je stavová poznámka (bez dílčí částky). „Označit zaplaceno“ dokončí na Zaplaceno.`)
};

const en_deal_payments_partial_hint = /** @type {(inputs: Deal_Payments_Partial_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially paid is a status note (no separate paid amount). “Mark paid” completes to Paid.`)
};

/**
* | output |
* | --- |
* | "Partially paid is a status note (no separate paid amount). “Mark paid” completes to Paid." |
*
* @param {Deal_Payments_Partial_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_partial_hint = /** @type {((inputs?: Deal_Payments_Partial_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Partial_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_partial_hint(inputs)
	return cs_deal_payments_partial_hint(inputs)
});